import React from "react";
import { useAuth } from "../../contexts/AuthContext";
import SRDashboard from "./sr/SRDashboard";
import SMDashboard from "./sm/SMDashboard";

function DashboardRouter() {
  const { user } = useAuth();
  const role = String(user?.role || "").trim();

  const isOwner = ["Admin", "SM", "Sales Owner", "Sales Manager"].includes(role);

  if (isOwner) {
    return <SMDashboard />;
  }
  return <SRDashboard />;
}

export default DashboardRouter;